<template>
  <widget-wrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="chartAttr.addtxt"
    :defaultTitle="chartAttr.title"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    @ctrl="ctrlClick"
    class="default6 monitoring-status"
    ref="monitoringStatus"
  >
    <div class="content">
      <div class="area2">
        <div ref="mornitringGroup" class="mornitring-group">
          <c-scroll>
            <GroupItem
              v-for="item in productGroups"
              :group="item"
              :key="item.productTypeCode"
              :selectedProductGroup="selectedProductGroup"
              @changeGroup="onSelectProductGroup"
            />
          </c-scroll>
        </div>
      </div>
      <div class="area3">
        <div class="arrow-right2" />
        <c-scroll style="padding-right: 10px">
          <ServiceItem
            v-for="item in productItems"
            :service="item"
            :isSettingMode="isSettingMode"
            :key="item.productTypeCode"
          />
        </c-scroll>
      </div>
      <div class="line"></div>
      <div class="area1">
        <div class="surmary">
          <div class="title">
            <div>{{ $t('label.total') }}</div>
            <div>{{ total }}</div>
          </div>

          <div class="gauge" v-if="total">
            <div
              class="running gauge-bar"
              v-if="running"
              :style="'width:calc(' + (running / total) * 100 + '%'"
            >
              <div class="gauge-status">
                {{ running }}
              </div>
            </div>

            <div
              class="down lego-screen gauge-bar"
              v-if="down"
              :style="`width:calc((${down} / ${total}) * 100%)`"
            >
              <div class="gauge-status has-pointer">
                {{ down }}
              </div>
              <lego-popover
                v-if="tooltipDown"
                class="hover-stay scroll-dark details-tooltip"
                :manualClose="true"
                :left="checkPosition()"
              >
                <slot name="tooltip">
                  <div v-html="tooltipDown"></div>
                </slot>
              </lego-popover>
            </div>

            <div
              class="ne lego-screen gauge-bar"
              v-if="ne"
              :style="`width:calc((${ne} / ${total}) * 100%`"
            >
              <div class="gauge-status has-pointer">
                {{ ne }}
              </div>
              <lego-popover
                v-if="tooltipNe"
                class="hover-stay scroll-dark details-tooltip"
                :manualClose="true"
                :left="checkPosition()"
              >
                <slot name="tooltip">
                  <div v-html="tooltipNe"></div>
                </slot>
              </lego-popover>
            </div>
          </div>

          <div class="status" v-if="total">
            <div class="status__box">
              <div class="status__box__icon running"></div>
              <div class="status__box__text cursor-default">
                {{ $const.PRODUCTS_STATE.RUNNING }}
              </div>
            </div>

            <div class="lego-screen">
              <div :class="{ status__box: true, 'has-pointer': down }">
                <div class="status__box__icon down"></div>
                <div :class="['status__box__text', { 'cursor-default': !tooltipDown }]">
                  {{ $const.PRODUCTS_STATE.DOWN }}
                </div>
              </div>
              <lego-popover
                v-if="tooltipDown"
                class="hover-stay scroll-dark details-tooltip"
                :manualClose="true"
                :left="checkPosition()"
              >
                <slot name="tooltip">
                  <div v-html="tooltipDown"></div>
                </slot>
              </lego-popover>
            </div>

            <div class="lego-screen">
              <div :class="{ status__box: true, 'has-pointer': ne }">
                <div class="status__box__icon ne"></div>
                <div :class="['status__box__text', { 'cursor-default': !tooltipNe }]">
                  {{ $const.PRODUCTS_STATE.UNKNOWN }}
                </div>
              </div>

              <lego-popover
                v-if="tooltipNe"
                class="hover-stay scroll-dark details-tooltip"
                :manualClose="true"
                :left="checkPosition()"
              >
                <slot name="tooltip">
                  <div v-html="tooltipNe"></div>
                </slot>
              </lego-popover>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="event-level">
          <div class="event-level__title">
            <div>{{ $t('searchLabel.eventLevel') }}</div>
            <div>{{ totalActiveEvent || 0 }}</div>
          </div>
          <div class="event-level__box">
            <div class="event-level__section fatal">
              <div class="event-level__text icon-fatal" v-lego-tooltip="'Fatal'">F</div>

              <div class="event-level__section__count">{{ amountActiveEventFatal || 0 }}</div>
            </div>

            <div class="event-level__section warning">
              <div class="event-level__text icon-warning" v-lego-tooltip="'Warning'">W</div>

              <div class="event-level__section__count">{{ amountActiveEventWarning || 0 }}</div>
            </div>

            <div class="event-level__section inform">
              <div class="event-level__text icon-inform" v-lego-tooltip="'Inform'">I</div>

              <div class="event-level__section__count">{{ amountActiveEventInform || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </widget-wrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from '@/containers/widget/components/widgetMixin';
import {
  getProductMonitoringCount,
  getResourceTypeDatas,
  getProductStatusDatas
} from '@/containers/widget/serviceApi';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';
import GroupItem from './GroupItem.vue';
import ServiceItem from './ServiceItem.vue';

const { getOriginalProductTypeGroups } = useProductTypeGroups();

export default {
  components: { widgetWrapper, ServiceItem, GroupItem },
  mixins: [widgetMixin],
  props: {
    searchDate: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    empty() {
      return !this.isWidgetAuth;
    },
    productItems() {
      if (this.productGroups.length > 0) {
        const group = this.productGroups.find(
          (item) => item.productTypeName === this.selectedProductGroup
        );
        return group.children;
      }

      return [];
    }
  },
  data() {
    return {
      total: 0, // 상품별 모니터링 대상 총 개수
      running: 0, // Running 상태 개수
      down: 0, // Down 상태 개수
      unknown: 0,
      ne: 0,
      totalActiveEvent: 0,
      amountActiveEventFatal: 0,
      amountActiveEventInform: 0,
      amountActiveEventWarning: 0,
      isEventRuleSetting: 0, // 이벤트 설정 개수
      isLogCollect: 0, // 로그 수집 개수
      isMetricDataCollect: 0, // 성능 수집 개수
      productGroups: [],
      selectedProductGroup: 'Compute', // 선택된 상위 그룹
      tooltipDown: '',
      tooltipUnknown: '',
      tooltipNe: ''
    };
  },
  methods: {
    buildGroupTree(parent, data) {
      let count = parent ? parent.count : 0;
      let children = [];
      let urlCode = parent ? parent.productTypeCode : '';

      const subGroups = data.filter(
        (item) =>
          item.parentProductTypeName === parent.productTypeName &&
          item.productTypeSq != parent.productTypeSq
      );

      if (subGroups.length > 0 && parent.productTypeName !== parent.parentProductTypeName) {
        children = subGroups.map((item) => this.buildGroupTree(item, data));
        count = children.reduce((total, item) => total + item.count, 0);
        urlCode = children[0].productTypeCode;
      }

      return {
        ...parent,
        children,
        count,
        urlCode
      };
    },
    addCountToGroup(data, counters) {
      return data.map((item) => {
        const counter = counters.find((cnt) => item.productTypeCode === cnt.productTypeCode);
        return {
          ...item,
          count: counter?.count || 0
        };
      });
    },

    // 모니터링 현황 API call getData...
    async setProductGroupInfo(data) {
      const originalGroups = await getOriginalProductTypeGroups();

      const params = {
        queryStartDt: this.searchDate.queryStartDt,
        queryEndDt: this.searchDate.queryEndDt,
        timeZone: 'UTC'
      };

      const productRes = await getProductMonitoringCount(this.header, params);
      if (productRes instanceof Error) return;
      const [result] = productRes.contents;

      const dataWithCount = this.addCountToGroup(data, result.productTypeCount);
      this.productGroups = originalGroups.map((item) => this.buildGroupTree(item, dataWithCount));

      this.productCount = result.productTypeCount;
      this.total = result.total;
      this.running = result.running;
      this.down = result.down;
      this.unknown = result.unknown;
      this.ne = result.ne;
      this.totalActiveEvent = result.totalActiveEvent;
      this.amountActiveEventFatal = result.amountActiveEventFatal;
      this.amountActiveEventInform = result.amountActiveEventInform;
      this.amountActiveEventWarning = result.amountActiveEventWarning;
      this.isEventRuleSetting = result.isEventRuleSetting;
      this.isLogCollect = result.isLogCollect;
      this.isMetricDataCollect = result.isMetricDataCollect;

      this.onSelectProductGroup(this.selectedProductGroup);
    },

    // 상품유형 정보 API call
    getData() {
      getResourceTypeDatas(this.header).then((data) => {
        if (data instanceof Error) return;
        this.setProductGroupInfo(data);
      });

      // Down 된  상품의 리스트 목록 가져오기
      getProductStatusDatas('Down', this.header).then((data) => {
        if (data instanceof Error) return;
        let html = '';
        data.forEach((item) => {
          html += item.productName + ' (' + item.productTypeName + ') <br>';
        });
        this.tooltipDown = html;
      });

      getProductStatusDatas('Ne', this.header).then((data) => {
        if (data instanceof Error) return;
        let html = '';
        data.forEach((item) => {
          html += item.productName + ' (' + item.productTypeName + ') <br>';
        });
        this.tooltipNe = html;
      });
    },

    // 상품 그룹 선택 Event
    onSelectProductGroup(name) {
      this.selectedProductGroup = name;
    },

    checkPosition() {
      if (!this.isCustomDashboard) return false;
      return this.configItem.x >= 3 || this.isSettingMode;
    }
  }
};
</script>
<style lang="scss" scoped>
$withCalc: calc((100% - 250px - 19px - 8px * 3) / 2); // 250 : area1, 19: line, 8: gap *3

.has-pointer {
  cursor: pointer !important;
  user-select: none;
}

.monitoring-status {
  overflow: unset !important;
}

.content {
  display: flex;
  gap: 8px;
  max-height: 100%;

  .area1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    padding-left: 3px;

    .title,
    .event-level__title {
      display: flex;
      justify-content: space-between;
      color: #2f3237;
      font-family: $lego__font-family;
      font-style: normal;
      align-items: flex-end;
      height: 21px;

      :first-child {
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;
      }

      :last-child {
        font-size: 20px;
        font-weight: 700;
        line-height: 20px;
      }
    }

    .event-level {
      display: flex;
      flex-direction: column;
      gap: 12px;

      &__text {
        cursor: default;
        user-select: none;
      }

      &__box {
        display: grid;

        grid-template-columns: auto auto auto;
        gap: 8px;
        line-height: normal;
        font-style: normal;
      }

      &__section {
        text-align: center;
        padding: 12px;
        border-radius: 4px;
        display: grid;
        gap: 8px;
        justify-content: center;

        ::v-deep {
          [_comment] {
            width: 24px !important;
            height: 24px !important;

            em {
              font-size: 12px;
              font-weight: 700;
              line-height: 16px;
            }
          }
        }

        &.fatal {
          background: #fee6e7;
        }

        &.warning {
          background: #fff5d6;
        }

        &.inform {
          background: #f7f7f8;
        }

        &__count {
          font-size: 18px;
          font-weight: 700;
          cursor: default;
        }
      }

      &__icon-type {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &__text {
        display: flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        color: #fff;

        &.icon-fatal {
          background: #fb6a72;
        }

        &.icon-inform {
          background: #8a8f99;
        }

        &.icon-warning {
          background: #ffcf33;
        }
      }

      .status {
        display: flex;
        justify-content: space-between;
      }
    }

    .surmary {
      display: grid;
      gap: 12px;
      height: 75px;

      .gauge {
        display: flex;
        // border-radius: 4px;
        // overflow: hidden;
        height: 14px;

        .gauge-bar {
          min-width: 6%;

          &:first-child {
            border-top-left-radius: 4px !important;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 4px !important;
          }

          &:last-child {
            border-top-left-radius: 0px;
            border-top-right-radius: 4px !important;
            border-bottom-right-radius: 4px !important;
            border-bottom-left-radius: 0px;
          }
        }

        .gauge-status {
          font-size: 10px;
          font-weight: 700;
          line-height: 14px;
          color: #fff;
          text-align: center;
          cursor: default;
        }
      }

      .running {
        background-color: #23d79e !important;
      }

      .down {
        background-color: #fb4b57 !important;
      }

      .unknown {
        background-color: #b5b9bf !important;
      }

      .ne {
        background-color: #a386ef !important;
      }

      .lego-screen {
        background-color: transparent;
        width: max-content;
      }

      .status {
        display: flex;
        justify-content: space-between;

        &__box {
          display: flex;
          align-items: center;
          gap: 4px;

          &__text {
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 12px;
          }

          .cursor-default {
            cursor: default;
          }

          &__icon {
            border-radius: 50%;
            min-width: 10px;
            height: 10px;
            color: black;
            text-align: center;
            display: inline-block;
          }
        }
      }
    }

    .divider {
      height: 1px;
      background: #e4e5e7;
      margin: 14.5px 0px;
    }
  }

  .line {
    width: 1px;
    margin: 0 8px;
    background: #eaeaea;
    height: auto !important;
  }

  .area2 {
    width: $withCalc;
    z-index: 1;
    min-height: 216px;

    .title {
      height: 20px;
      font-family: $lego__font-family;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: left;
      color: var(--dark);
    }
  }

  .area3 {
    width: $withCalc;
    padding: 12px 0;
    background-color: #f7f7f8;
    position: relative;
    border-radius: 4px;
    min-height: 216px !important;

    .arrow-right2 {
      width: 0;
      height: 0;
      top: 50%;
      border-top: 9px solid transparent;
      border-bottom: 9px solid transparent;
      border-left: 9px solid white;
      position: absolute;
      left: -1.2px;
    }

    .title {
      display: flex;
      align-items: center;
      height: 42px;
      font-family: $lego__font-family;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: var(--dark);
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
